<template>
  <form
    name="richTextBlogItemForm"
    @submit.prevent="createBlogItem">
    <v-row class="align-center">
      <!-- Title -->
      <v-col>
        <v-text-field
          hide-details
          label="Title"
          placeholder=" "
          v-model="blogItem.title">
        </v-text-field>
      </v-col>
      <!-- / Title -->

      <!-- Date -->
      <v-col cols="auto">
        <DatePicker
          input-id="blog-date"
          v-model="blogItem.date"
          label="Date"
          :line-bottom="true"
        />
      </v-col>
      <!-- / Date -->

      <!-- Hidden -->
      <v-col cols="auto"
        class="hidden-checkbox col-auto">
        <v-checkbox
          height="28"
          label="Hidden"
          v-model="blogHidden">
        </v-checkbox>
      </v-col>
      <!-- / Hidden -->
    </v-row>

    <div class="row">
      <div class="col">
        <label class="d-block mb-1">Image:</label>
        <ImageInput
          :aspectRatioWidth="this.$store.state.blogImageDimensions.blogImageWidth"
          :aspectRatioHeight="this.$store.state.blogImageDimensions.blogImageHeight"
          :imageMode="this.$store.state.cropImageInformation.imageMode"
          :src="this.$store.state.cropImageInformation.imageSrc"
        />

          <div class="d-flex justify-space-between">
            <p>
              Suggested Image Size:
              {{this.determineRecommendedImageSize()}}
            </p>

            <p v-if="this.$store.state.cropImageInformation.imageMode === 'crop'">
              Crop Box Dimensions:
              {{this.CropBoxDimensions}}
            </p>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="page-buttons d-flex my-5">
        <v-btn
          type="button"
          color="primary"
          class="order-4"
          :disabled="this.$store.state.cropImageInformation.imageMode === 'view'"
          @click="cropImage()">
          Crop
        </v-btn>

        <v-btn
          type="button"
          color="primary"
          class="mr-5 order-2"
          :disabled="this.$store.state.cropImageInformation.imageSrc === ''"
          @click="clearImageSrc()">
          Remove
        </v-btn>

        <v-btn
          type="button"
          color="primary"
          class="mr-5 order-1 margin-left"
          outlined
          @click="$refs.fileUpload.click()">
          Upload
          <input
            ref="fileUpload"
            @input="receiveFile($refs.fileUpload.files)"
            type="file"
            accept="image/png,image/gif,image/jpeg"
            hidden
          />
        </v-btn>
      </div>
    </div>

    <v-divider></v-divider>

    <WYSIWYG
      class="page-tab-content-expand"
      v-model="blogItem.content">
    </WYSIWYG>

    <div class="page-buttons d-flex my-5">
      <v-btn
        type="submit"
        color="primary"
      >
        Save
      </v-btn>

      <v-btn
        @click="goToBlogList"
        type="button"
        color="primary"
        class="mr-auto order-first"
        outlined>
        Cancel
      </v-btn>
    </div>
  </form>
</template>

<script>
import _ from 'lodash';
import BlogItemMixin from '../mixin.blog-item';
import WYSIWYG from './WYSIWYG/WYSIWYG.vue';
import DatePicker from './DatePicker.vue';
import ImageInput from './ImageInput.vue';

export default {
  name: 'BlogCreateForm',
  mixins: [
    BlogItemMixin,
  ],
  components: {
    WYSIWYG,
    DatePicker,
    ImageInput,
  },
  computed: {
    CropBoxDimensions() {
      return this.$store.getters.cropBoxDimensions;
    },
  },
  watch: {
    immediate: true,
    CropBoxDimensions(newDimensions, oldDimensions) {
      let returnValue = null;
      if (newDimensions !== oldDimensions) {
        returnValue = newDimensions;
      }

      return returnValue;
    },
  },
  created() {
    this.$store.dispatch('getBlogImageDimensions');
  },
  mounted() {
    this.$store.dispatch('setDefaultBlogItem');
    this.$store.dispatch('clearCropImageTempSrc');
  },
  methods: {
    receiveFile(files) {
      if (!files) return;

      files = Array.from(files);

      const image = this.validateFile(files);

      if (!image) return;

      this.clearImageSrc();

      const reader = new FileReader();

      reader.onload = (e) => {
        this.setCropImageTempSrc(e.target.result);
      };

      reader.readAsDataURL(image);
      this.$refs.fileUpload.value = '';
    },
    validateFile(files) {
      const errors = [];
      let [image] = files;
      const size = (image.size / 1024 / 1024).toFixed(4);

      if (files.length !== 1) {
        errors.push('&bull; You may only upload one image file at a time.');
      }

      if (!_.includes(image.type, 'image')) {
        errors.push('&bull; You may only upload image files (JPG, PNG, & GIF)');
      }

      if (size > 5) {
        errors.push('&bull; Image file size may not exceed 5MB.');
      }

      if (errors.length) {
        image = false;
        this.showWarning(
          errors.join('<br>'),
          'The following errors occured',
        );
      }

      return image;
    },
    clearImageSrc() {
      this.clearCropImageTempSrc();
    },
    cropImage() {
      this.cropAndSaveImage();
    },
  },
};
</script>

<style lang="scss"></style>
